import { render, staticRenderFns } from "./ReferenceThirdParties.vue?vue&type=template&id=774f49de&"
import script from "./ReferenceThirdParties.vue?vue&type=script&lang=js&"
export * from "./ReferenceThirdParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports